import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useWalletClient } from 'wagmi';

import { setWalletClient } from 'modules/api/walletClient';

import {
  selectConnectionType,
  setConnectionKey,
} from '../store/connectionSlice';
import {
  SELECTED_CONNECTION_TYPE,
  useReownConnection,
} from './useReownConnection';
import { useUpdateConnectionState } from './useUpdateConnectionState';

export function useWatchReown(): void {
  const dispatch = useDispatch();
  const { data: walletClient } = useWalletClient();

  const connectionType = useSelector(selectConnectionType);

  const {
    isConnected,
    getWalletKey,
    chainId,
    disconnect,
    walletIcon,
    accountAddress,
  } = useReownConnection();

  useUpdateConnectionState({
    type: SELECTED_CONNECTION_TYPE,
    chainId,
    isConnected,
    accountAddress,
    walletIcon,
    disconnect,
  });

  // update wallet client from appkit
  useEffect(() => {
    if (connectionType !== SELECTED_CONNECTION_TYPE) {
      return;
    }

    const isUpdateWalletClient = isConnected && walletClient;
    if (!isUpdateWalletClient) {
      return;
    }

    setWalletClient(walletClient);
    dispatch(
      setConnectionKey({ type: SELECTED_CONNECTION_TYPE, key: getWalletKey() }),
    );
  }, [isConnected, connectionType, walletClient, dispatch, getWalletKey]);
}
